<template>
  <v-row no-gutters class="pt-5 pr-2">
    <v-col v-if="computedIsFetched">
      <card-title-row translation-path="sidebar.scada" :amount="1" :is-plural="true" />
      <card-title-row
        is-subtitle
        translation-path="sidebar.visualisationOnMap"
        :amount="1"
        :is-plural="true"
        class="pt-2"
      />
      <sidebar-row class="pt-2">
        <sidebar-select-row
          translation-path="sidebar.visualizationType"
          font-size="14px"
          @input="handleStyleChange"
          :value="currentStyle"
          :select-props="styleSelectProps"
        />
      </sidebar-row>
      <module-legend ref="moduleLegend" border-bottom module-name="scada" />

      <card-title-row
        is-subtitle
        translation-path="sidebar.visualisationByAttributes"
        :amount="1"
        :is-plural="true"
        class="pt-3 pb-1"
      />
      <sidebar-row>
        <sidebar-checkboxes-filter :attributes="scadaCheckboxesFilterAttributes" />
      </sidebar-row>
    </v-col>
    <main-loader v-else></main-loader>
  </v-row>
</template>

<script>
import { call, get } from 'vuex-pathify';

import CardTitleRow from '@/components/CardTitleRow';
import MainLoader from '@/components/MainLoader';
import SidebarCheckboxesFilter from '@/components/SidebarCheckboxesFilter';
import SidebarSelectRow from '@/components/SidebarSelectRow';
import SidebarRow from '@/components/SidebarRow';
import ModuleLegend from '@/components/ModuleLegend';

export default {
  name: 'Scada',
  components: {
    ModuleLegend,
    SidebarRow,
    CardTitleRow,
    MainLoader,
    SidebarSelectRow,
    SidebarCheckboxesFilter,
  },
  computed: {
    attributesMetadata: get('layers/metadata@:dataSourceName.attributes_schema.attributes'),
    dataSourceName: get('admin/modulesMapping@scada.datasource_name'),
    currentStyle: get('styles/currentStyle@:dataSourceName'),
    defaultStyle: get('styles/defaultStyle@:dataSourceName'),
    scadaLayerId: get('admin/modulesMapping@scada.layer_id'),
    styles: get('styles/styles@:dataSourceName'),
    loaded: get('modules/loaded@:dataSourceName'),

    computedIsFetched() {
      return this.isFetched && this.loaded;
    },
    scadaCheckboxesFilterAttributes() {
      return this.attributesMetadata.filter(attribute => attribute.name === 'type');
    },
    computedSelectStyles() {
      return [this.defaultStyle, ...this.$_sortObjectsByAttribute([...this.styles], 'name')];
    },
    styleSelectProps() {
      return {
        items: this.computedSelectStyles,
        itemText: 'name',
        itemValue: 'id',
        returnObject: true,
      };
    },
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    getFeaturesLayer: call('layers/getFeaturesLayer'),
    getMetadata: call('layers/getLayerMetadata'),
    getScada: call('scada/getScada'),
    getStyles: call('styles/getStyles'),
    setCurrentStyle: call('styles/setCurrentStyle'),
    async handleStyleChange(style) {
      await this.setCurrentStyle({ dataSource: this.dataSourceName, style: style });
      this.$root.$emit('scadaStyleChanged', style);
      await this.$refs.moduleLegend.getModuleStyle();
    },
    async init() {
      await Promise.all([
        this.getScada(),
        this.getMetadata({ dataSource: this.dataSourceName }),
        this.getStyles(this.dataSourceName),
        this.getFeaturesLayer(this.scadaLayerId),
      ]);
      setTimeout(() => {
        this.$root.$emit('setSidebarFilters', { type: this.scadaCheckboxesFilterAttributes[0].allowed_values });
      });
      this.isFetched = true;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
